import Aurora from "./Aurora";
import TrinityLogo from "../../../assets/images/brands/Trinity.png";
import SONOKONGLogo from "../../../assets/images/brands/SONOKONG.png";
import ADBIOTECHLogo from "../../../assets/images/brands/ADBIOTECH.png";
import AGEDBLogo from "../../../assets/images/brands/AGEDB.png";
import HiTronLogo from "../../../assets/images/brands/HiTron.png";
import NANOsLogo from "../../../assets/images/brands/NANOs.png";
import GLITCHLogo from "../../../assets/images/brands/GLITCH.png";

export default function Section1() {
  return (
    <section className="relative z-10 w-full flex flex-col items-center justify-center overflow-hidden min-h-screen mb-[80px] md:mb-[130px] lg:mb-[150px] pt-[80px] md:pt-[130px] lg:pt-[150px]">
      <div className="absolute inset-0 z-0 pointer-events-none">
        <Aurora
          colorStops={["#ed66ff", "#b19eef", "#5227ff"]}
          amplitude={1.2}
          blend={0.6}
          speed={0.8}
        />
      </div>
      <div className="relative z-10 flex flex-col items-center justify-center px-4 md:px-8">
        <div className="flex flex-col items-center justify-center text-center w-full mx-auto mb-[80px] md:mb-[130px] lg:mb-[150px]">
          <h1 className="text-[30px] md:text-[50px] lg:text-[50px] font-normal text-white mb-6 tracking-tight">
            Real Value, Instantly Connected
          </h1>

          <h2 className="text-[30px] md:text-[48px] lg:text-[48px] font-normal text-white mb-6 tracking-tight">
            The RWA liquidity layer for everyday commerce
          </h2>

          <p className="text-[16px] md:text-[18px] lg:text-[21px] text-white mb-8 w-full leading-relaxed">
            Switch turns real-world payments into programmable liquidity
            <br />
            creating instant settlement, unified value flows, and a
            self-expanding on-chain economy
          </p>

          <a
            href="https://switch-protocol.gitbook.io/switch-protocol/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-gray-300 text-gray-800 rounded-full font-medium uppercase tracking-wide hover:bg-gray-200 transition-colors"
          >
            VIEW WHITEPAPER
          </a>
        </div>

        <div className="flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
          <p className="text-[12px] md:text-[14px] lg:text-[15px] text-white max-w-2xl leading-relaxed text-center">
            Discover how real-world commerce becomes programmable liquidity
          </p>
        </div>

        <div className="flex flex-col items-center justify-center">
          <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:flex lg:flex-wrap items-center justify-center gap-8">
            <img
              src={TrinityLogo}
              alt="Trinity"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
            <img
              src={SONOKONGLogo}
              alt="SONOKONG"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
            <img
              src={ADBIOTECHLogo}
              alt="ADBIOTECH"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
            <img
              src={AGEDBLogo}
              alt="AGEDB"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
            <img
              src={HiTronLogo}
              alt="HiTron"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
            <img
              src={NANOsLogo}
              alt="NANOs"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
            <img
              src={GLITCHLogo}
              alt="GLITCH"
              className="h-10 w-auto object-contain justify-self-center md:justify-self-center lg:justify-self-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
